 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		11: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~vsf-category~vsf-home~vsf-my-account~vsf-product~vsf-search-panel-desktop~vsf-search-panel-m~de07e711","1":"vsf-category~vsf-home~vsf-my-account~vsf-related~vsf-search-panel-desktop~vsf-search-panel-mobile~vs~57c298de","2":"vendors~vue-carousel","3":"vendors~bodybuilder~vsf-related","4":"vsf-checkout~vsf-my-account","5":"vsf-checkout~vsf-register","6":"vsf-microcart~vsf-product","7":"vsf-search-panel-desktop~vsf-search-panel-mobile","8":"SwipeActions","10":"dayjs-locales-pl","13":"vendors~vsf-account-icon","14":"vendors~vsf-checkout","15":"vendors~vsf-graphql","16":"vendors~vsf-search-panel-mobile","17":"vsf-account-icon","18":"vsf-category","19":"vsf-checkout","20":"vsf-cms","21":"vsf-error","22":"vsf-forgotpass","23":"vsf-home","24":"vsf-layout-default","25":"vsf-login","26":"vsf-microcart","27":"vsf-my-account","28":"vsf-not-found","29":"vsf-order-confirmation","30":"vsf-placepozniej","31":"vsf-product","32":"vsf-product-gallery-carousel","33":"vsf-product-gallery-overlay","34":"vsf-product-tabs","35":"vsf-register","36":"vsf-related","37":"vsf-reset-password","38":"vsf-search-adapter-api-search-query-searchAdapter","39":"vsf-search-adapter-api-searchAdapter","40":"vsf-search-adapter-graphql-searchAdapter","41":"vsf-search-panel-desktop","42":"vsf-search-panel-mobile","43":"vsf-sidebar-menu","44":"vsf-typ","45":"vsf-wishlist"}[chunkId]||chunkId) + "." + {"0":"968872bc8f0fbde00737","1":"47ec2167f2ee427ba2d3","2":"74de64a95a54f23ff522","3":"05f354875b41ce1b0306","4":"7368ecd75617869fde13","5":"aa0e6ae6a61ac9413df8","6":"dcc9b6882ee576ae0b94","7":"fe5930d23a49578da230","8":"4a9474cfcd9fce8f5359","10":"dec83a474a47b7bbc5fa","13":"93e450802fc8e744f579","14":"aa2785e638dadb59dfad","15":"6215fb3d8d6659a109f9","16":"5416111a455297e9ea92","17":"e90f3325518bba560873","18":"69c6361598a53e771391","19":"75a50df75d529609dc9c","20":"210d09bd55128ac1a73f","21":"0dffa2495568684ca050","22":"5e89e66cc4628423b47e","23":"9d77a61a5c6c80a7cbbb","24":"6852e8a14f5a1946c0f4","25":"e84d506f3b6503598726","26":"33dcb37bbc12c8f5632e","27":"6bd94cc8e858f84d7cc9","28":"112e3bd8cfd43e32af5a","29":"6a44d8650f1edb54b5bf","30":"b9cb7c8fdb09352c2287","31":"fbf223d178433f4495f5","32":"c7509b2a0df199190419","33":"f7c614fb1b55420df7ae","34":"fd4fbcba9486fdd172bd","35":"ba6a5d2bbdf1f3ec0c41","36":"e3c8b3df25b270b0a308","37":"927cc6bbeb8725240f45","38":"ee51b4bca6fcfe36920b","39":"a55e2ea6e013a92fea1c","40":"a13509336f5640aae0ab","41":"17baf3733cb27c233552","42":"31ed4f75d2e676c4586f","43":"284fcd8a9c10f178ddf2","44":"7ab5001a5afc87065e53","45":"307892b6cd96190c1f9c","46":"7cfa317702c187179ead","47":"d0b1aba95bcb22e116d3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"24": [
 				0,
 				1,
 				45,
 				6,
 				26,
 				43
 			],
 			"26": [
 				8
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
